// start:ng42.barrel
export * from './etiqueta-autocomplete.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/etiqueta-autocomplete/index.ts